import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import axios from 'axios'

/* NOTES */
const Index = () => import('@/catalog/Index')
const Main = () => import('@/catalog/Main')
const PersonalPage = () => import('@/catalog/services/PersonalPage')
const IndexCalendar = () => import('@/booking/IndexCalendar')
const Booking = () => import('@/booking/Booking')
const Table = () => import('@/booking/Table')
const MenuServices = () => import('@/catalog/services/MenuServices')
const CatalogServices = () => import('@/catalog/services/Services')
const CatalogPlaces = () => import('@/catalog/services/Places')
const MenuPlaces = () => import('@/catalog/services/MenuPlaces')
const Slider = () => import('@/booking/notes/slider/Slider')
const Contacts = () => import('@/booking/notes/contacts/Contacts')
const Social = () => import('@/booking/notes/social/Social')
const About = () => import('@/booking/notes/about/About')
const Gallery = () => import('@/booking/notes/gallery/Gallery')
const Team = () => import('@/booking/notes/team/Team')
const TeamForm = () => import('@/booking/notes/team/TeamForm')
const Error404 = () => import('@/catalog/other/Error404')
const MenuPage = () => import('@/booking/notes/menuPage/MenuPage')
const BookingPage = () => import('@/booking/notes/bookingPage/BookingPage')
/* ----- */
const Polsog = () => import('@/booking/Polsog')

/* Профиль */
const Profile = () => import('@/booking/profile/Profile')
const ProfileBooking = () => import('@/booking/profile/ProfileBooking')
const ProfileEmployeeBooking = () => import('@/booking/employees/EmployeeCart')
const ProfileEdit = () => import('@/booking/profile/ProfileEdit')

const Admins = () => import('@/booking/admins/Admins')
const AdminForm = () => import('@/booking/admins/AdminForm')

const Filials = () => import('@/booking/filials/Filials')
const FilialForm = () => import('@/booking/filials/FilialForm')

/* Исполнители */
const Employees = () => import('@/booking/employees/Employees')
const EmployeeCart = () => import('@/booking/employees/EmployeeCart')
const EmployeeForm = () => import('@/booking/employees/EmployeeForm')
const EmployeeCalendar = () => import('@/booking/employees/EmployeeCalendar')
const EmployeeServices = () => import('@/booking/employees/EmployeeServices')

/* Официанты */
const Waiters = () => import('@/booking/waiters/Waiters')
const WaiterCart = () => import('@/booking/waiters/WaiterCart')
const WaiterForm = () => import('@/booking/waiters/WaiterForm')
const WaiterCalendar = () => import('@/booking/waiters/WaiterCalendar')
const WaiterTable = () => import('@/booking/waiters/WaiterTable')

/* Клиенты */
const Clients = () => import('@/booking/clients/Clients')
const ClientCart = () => import('@/booking/clients/ClientCart')
const ClientForm = () => import('@/booking/clients/ClientForm')

/* Категории клиентов */
const Categories = () => import('@/booking/categories/Categories')
const CategoryForm = () => import('@/booking/categories/CategoryForm')

/* Категории мастеров */
const EmployeeCategories = () => import('@/booking/employee-categories/EmployeeCategories')
const EmployeeCategoryForm = () => import('@/booking/employee-categories/EmployeeCategoryForm')

/* Услуги */
const Services = () => import('@/booking/services/Services')
const ServiceForm = () => import('@/booking/services/ServiceForm')

/* Столики */
const Tables = () => import('@/booking/tables/Tables')
const TableForm = () => import('@/booking/tables/TableForm')

/* Программа лояльности */
const Loyalty = () => import('@/booking/loyalty/Loyalty')

/* Уведомления */
const Notification = () => import('@/booking/notification/Notification')
const Settings = () => import('@/booking/notification/Settings')

/* Статьи */
const Articles = () => import('@/booking/articles/Articles')
const ArticleForm = () => import('@/booking/articles/ArticleForm')

/* Админпанель */
const ControlMain = () => import('@/control/ControlMain')
const Partners = () => import('@/control/partners/Partners')
const PartnerCart = () => import('@/control/partners/PartnerCart')
const PartnerForm = () => import('@/control/partners/PartnerForm')

const Countries = () => import('@/control/cities/Countries')
const CountryForm = () => import('@/control/cities/CountryForm')

/* Custom Landing Page */
const Irene = () => import('@/customs/irene/Irene')
Vue.use(Router)
const router = new Router({
  mode: 'history',
  routes: [
	  {
      path: '/',
      component: Irene,
      meta: {
        title: '«IRENE» Nail Room'
      },
      beforeEnter: (to, from, next) => {
        axios.get(store.state.api.url + 'catalog/init-personal-page?link=main', { withCredentials: true })
          .then((response) => {
            if (response.data.status === 'success') {
              store.commit('initPageInfo', response.data.catalog)
              store.commit('pageInfo', response.data.pageInfo)
              store.commit('viewMode', response.data.viewMode)
              next()
            } else {
              router.push('/404')
            }
            store.commit('globalPreloader', false)
          })
          .catch(function (error) {
            console.log(error)
          })
      },
		  children: [
			  // {
			  //   path: '/',
			  //   components: { place: Table, service: Booking }
			  // },
			  {
				  path: '/',
				  component: IndexCalendar,
				  beforeEnter: (to, from, next) => {
					  next()
					  router.push('/booking')
				  },
				  children: [
					  {
						  path: 'booking',
						  component: Booking
					  },
					  {
						  path: 'table',
						  component: Table
					  },
						{
							path: 'polsog',
							component: Polsog
						},
					  {
						  path: 'profile',
						  component: {
							  render (c) { return c('router-view') }
						  },
						  children: [
							  {
								  path: '',
								  component: Profile
							  },
							  {
								  path: 'edit',
								  component: ProfileEdit
							  },
							  {
								  path: 'booking',
								  component: ProfileBooking
							  },
							  {
								  path: 'employee-booking',
								  component: ProfileEmployeeBooking
							  }
						  ]
					  },
					  {
						  path: 'employees',
						  component: {
							  render (c) { return c('router-view') }
						  },
						  children: [
							  {
								  path: '',
								  component: Employees
							  },
							  {
								  path: 'cart/:id',
								  meta: { label: 'Карточка исполнителя' },
								  component: EmployeeCart
							  },
							  {
								  path: 'form/:id',
								  meta: { label: 'Управление исполнителем' },
								  component: EmployeeForm
							  },
							  {
								  path: 'calendar/:id',
								  meta: { label: 'График работы' },
								  component: EmployeeCalendar
							  },
							  {
								  path: 'services/:id',
								  meta: { label: 'Услуги исполнителя' },
								  component: EmployeeServices
							  }
						  ]
					  },
            {
              path: 'admins',
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: '',
                  component: Admins
                },
                {
                  path: 'form/:id',
                  meta: { label: 'Управление администратором' },
                  component: AdminForm
                }
              ]
            },
            {
              path: 'filials',
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: '',
                  component: Filials
                },
                {
                  path: 'form/:id',
                  meta: { label: 'Управление адресами' },
                  component: FilialForm
                }
              ]
            },
					  {
						  path: 'waiters',
						  component: {
							  render (c) { return c('router-view') }
						  },
						  children: [
							  {
								  path: '',
								  component: Waiters
							  },
							  {
								  path: 'cart/:id',
								  component: WaiterCart
							  },
							  {
								  path: 'form/:id',
								  component: WaiterForm
							  },
							  {
								  path: 'calendar/:id',
								  meta: { label: 'График работы' },
								  component: WaiterCalendar
							  },
							  {
								  path: 'table/:id/:day/:month/:year',
								  meta: { label: 'График работы' },
								  component: WaiterTable
							  }
						  ]
					  },
					  {
						  path: 'clients',
						  component: {
							  render (c) { return c('router-view') }
						  },
						  children: [
							  {
								  path: '',
								  component: Clients
							  },
							  {
								  path: 'cart/:id',
								  meta: { label: 'Карточка клиента' },
								  component: ClientCart
							  },
							  {
								  path: 'form/:id',
								  meta: { label: 'Управление клиентом' },
								  component: ClientForm
							  }
						  ]
					  },
					  {
						  path: 'categories',
						  component: {
							  render (c) { return c('router-view') }
						  },
						  children: [
							  {
								  path: '',
								  component: Categories
							  },
							  {
								  path: 'form/:id',
								  meta: { label: 'Управление категорией' },
								  component: CategoryForm
							  }
						  ]
					  },
					  {
						  path: 'employee-categories',
						  component: {
							  render (c) { return c('router-view') }
						  },
						  children: [
							  {
								  path: '',
								  component: EmployeeCategories
							  },
							  {
								  path: 'form/:id',
								  meta: { label: 'Управление категорией' },
								  component: EmployeeCategoryForm
							  }
						  ]
					  },
					  {
						  path: 'services',
						  component: {
							  render (c) { return c('router-view') }
						  },
						  children: [
							  {
								  path: '',
								  component: Services
							  },
							  {
								  path: 'form/:id',
								  meta: { label: 'Управление услугой' },
								  component: ServiceForm
							  }
						  ]
					  },
					  {
						  path: 'tables',
						  component: {
							  render (c) { return c('router-view') }
						  },
						  children: [
							  {
								  path: '',
								  component: Tables
							  },
							  {
								  path: 'form/:id',
								  component: TableForm
							  }
						  ]
					  },
					  {
						  path: 'articles',
						  component: {
							  render (c) { return c('router-view') }
						  },
						  children: [
							  {
								  path: '',
								  component: Articles
							  },
							  {
								  path: 'form/:id',
								  meta: { label: 'Управление контентом' },
								  component: ArticleForm
							  }
						  ]
					  },
					  {
						  path: 'loyalty',
						  component: {
							  render (c) { return c('router-view') }
						  },
						  children: [
							  {
								  path: '',
								  component: Loyalty
							  }
						  ]
					  },
					  {
						  path: 'notification',
						  component: {
							  render (c) { return c('router-view') }
						  },
						  children: [
							  {
								  path: '',
								  component: Notification
							  }
						  ]
					  },
						{
							path: 'settings',
							component: Settings
						},
					  {
						  path: 'slider',
						  component: {
							  render (c) { return c('router-view') }
						  },
						  children: [
							  {
								  path: '',
								  component: Slider
							  }
						  ]
					  },
					  {
						  path: 'contacts',
						  component: {
							  render (c) { return c('router-view') }
						  },
						  children: [
							  {
								  path: '',
								  component: Contacts
							  }
						  ]
					  },
					  {
						  path: 'social',
						  component: {
							  render (c) { return c('router-view') }
						  },
						  children: [
							  {
								  path: '',
								  component: Social
							  }
						  ]
					  },
					  {
						  path: 'about',
						  component: {
							  render (c) { return c('router-view') }
						  },
						  children: [
							  {
								  path: '',
								  component: About
							  }
						  ]
					  },
					  {
						  path: 'gallery',
						  component: {
							  render (c) { return c('router-view') }
						  },
						  children: [
							  {
								  path: '',
								  component: Gallery
							  }
						  ]
					  },
					  {
						  path: 'team',
						  component: {
							  render (c) { return c('router-view') }
						  },
						  children: [
							  {
								  path: '',
								  component: Team
							  },
							  {
								  path: 'form/:id',
								  meta: { label: 'Управление командой' },
								  component: TeamForm
							  }
						  ]
					  }
				  ]
			  }
		  ]
    },
    {
      path: 'control',
      component: Booking
    },
    /* ------------------- */
    /*{
      path: '/:link',
      component: PersonalPage,
      beforeEnter: (to, from, next) => {
        axios.get(store.state.api.url + 'catalog/init-personal-page?link=' + to.path, { withCredentials: true })
          .then((response) => {
            if (response.data.status === 'success') {
            	store.commit('initPageInfo', response.data.catalog)
	            store.commit('pageInfo', response.data.pageInfo)
	            store.commit('viewMode', response.data.viewMode)
              next()
            } else {
              router.push('/404')
            }
            store.commit('globalPreloader', false)
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      children: [
        // {
        //   path: '/',
        //   components: { place: Table, service: Booking }
        // },
        {
          path: '/',
          component: IndexCalendar,
	        beforeEnter: (to, from, next) => {
		        next()
		        if (store.state.initPageInfo.catalog_category === 1) {
			        router.push('/' + store.state.initPageInfo.catalog_link + '/booking')
		        } else {
			        router.push('/' + store.state.initPageInfo.catalog_link + '/table')
            }
	        },
          children: [
            {
		          path: 'booking',
		          component: Booking
	          },
	          {
		          path: 'table',
		          component: Table
	          },
	          {
		          path: 'profile',
		          component: {
			          render (c) { return c('router-view') }
		          },
		          children: [
			          {
				          path: '',
				          component: Profile
			          },
			          {
				          path: 'edit',
				          component: ProfileEdit
			          },
			          {
				          path: 'booking',
				          component: ProfileBooking
			          },
			          {
				          path: 'employee-booking',
				          component: ProfileEmployeeBooking
			          }
		          ]
	          },
	          {
		          path: 'employees',
		          component: {
			          render (c) { return c('router-view') }
		          },
		          children: [
			          {
				          path: '',
				          component: Employees
			          },
			          {
				          path: 'cart/:id',
				          meta: { label: 'Карточка исполнителя' },
				          component: EmployeeCart
			          },
			          {
				          path: 'form/:id',
				          meta: { label: 'Управление исполнителем' },
				          component: EmployeeForm
			          },
			          {
				          path: 'calendar/:id',
				          meta: { label: 'График работы' },
				          component: EmployeeCalendar
			          },
			          {
				          path: 'services/:id',
				          meta: { label: 'Услуги исполнителя' },
				          component: EmployeeServices
			          }
		          ]
	          },
	          {
		          path: 'waiters',
		          component: {
			          render (c) { return c('router-view') }
		          },
		          children: [
			          {
				          path: '',
				          component: Waiters
			          },
			          {
				          path: 'cart/:id',
				          component: WaiterCart
			          },
			          {
				          path: 'form/:id',
				          component: WaiterForm
			          },
			          {
				          path: 'calendar/:id',
				          meta: { label: 'График работы' },
				          component: WaiterCalendar
			          },
			          {
				          path: 'table/:id/:day/:month/:year',
				          meta: { label: 'График работы' },
				          component: WaiterTable
			          }
		          ]
	          },
	          {
		          path: 'clients',
		          component: {
			          render (c) { return c('router-view') }
		          },
		          children: [
			          {
				          path: '',
				          component: Clients
			          },
			          {
				          path: 'cart/:id',
				          meta: { label: 'Карточка клиента' },
				          component: ClientCart
			          },
			          {
				          path: 'form/:id',
				          meta: { label: 'Управление клиентом' },
				          component: ClientForm
			          }
		          ]
	          },
	          {
		          path: 'categories',
		          component: {
			          render (c) { return c('router-view') }
		          },
		          children: [
			          {
				          path: '',
				          component: Categories
			          },
			          {
				          path: 'form/:id',
				          meta: { label: 'Управление категорией' },
				          component: CategoryForm
			          }
		          ]
	          },
	          {
		          path: 'employee-categories',
		          component: {
			          render (c) { return c('router-view') }
		          },
		          children: [
			          {
				          path: '',
				          component: EmployeeCategories
			          },
			          {
				          path: 'form/:id',
				          meta: { label: 'Управление категорией' },
				          component: EmployeeCategoryForm
			          }
		          ]
	          },
	          {
		          path: 'services',
		          component: {
			          render (c) { return c('router-view') }
		          },
		          children: [
			          {
				          path: '',
				          component: Services
			          },
			          {
				          path: 'form/:id',
				          meta: { label: 'Управление услугой' },
				          component: ServiceForm
			          }
		          ]
	          },
	          {
		          path: 'tables',
		          component: {
			          render (c) { return c('router-view') }
		          },
		          children: [
			          {
				          path: '',
				          component: Tables
			          },
			          {
				          path: 'form/:id',
				          component: TableForm
			          }
		          ]
	          },
	          {
		          path: 'articles',
		          component: {
			          render (c) { return c('router-view') }
		          },
		          children: [
			          {
				          path: '',
				          component: Articles
			          },
			          {
				          path: 'form/:id',
				          meta: { label: 'Управление контентом' },
				          component: ArticleForm
			          }
		          ]
	          },
	          {
		          path: 'loyalty',
		          component: {
			          render (c) { return c('router-view') }
		          },
		          children: [
			          {
				          path: '',
				          component: Loyalty
			          }
		          ]
	          },
	          {
		          path: 'notification',
		          component: {
			          render (c) { return c('router-view') }
		          },
		          children: [
			          {
				          path: '',
				          component: Notification
			          }
		          ]
	          },
	          {
		          path: 'slider',
		          component: {
			          render (c) { return c('router-view') }
		          },
		          children: [
			          {
				          path: '',
				          component: Slider
			          }
		          ]
	          },
	          {
		          path: 'contacts',
		          component: {
			          render (c) { return c('router-view') }
		          },
		          children: [
			          {
				          path: '',
				          component: Contacts
			          }
		          ]
	          },
	          {
		          path: 'social',
		          component: {
			          render (c) { return c('router-view') }
		          },
		          children: [
			          {
				          path: '',
				          component: Social
			          }
		          ]
	          },
	          {
		          path: 'about',
		          component: {
			          render (c) { return c('router-view') }
		          },
		          children: [
			          {
				          path: '',
				          component: About
			          }
		          ]
	          },
	          {
		          path: 'gallery',
		          component: {
			          render (c) { return c('router-view') }
		          },
		          children: [
			          {
				          path: '',
				          component: Gallery
			          }
		          ]
	          },
	          {
		          path: 'team',
		          component: {
			          render (c) { return c('router-view') }
		          },
		          children: [
			          {
				          path: '',
				          component: Team
			          },
			          {
				          path: 'form/:id',
				          meta: { label: 'Управление командой' },
				          component: TeamForm
			          }
		          ]
	          }
          ]
        }
      ]
    }*/
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js